module.exports = __webpack_public_path__ + "static/media/firefox.0b73600a.png";